const errorSelectors = {
  getAllErrors: (state) => state.errorsReducer?.errors,
  getNextError: (state) => state.errorsReducer?.errors[0],
  isErrorsExist: (state) => state.errorsReducer?.errors.length > 0,
  errorCount: (state) => state.errorsReducer.errors?.length,
};

export default errorSelectors;
